import { Directive, input, model, ViewContainerRef } from '@angular/core';

@Directive( {
  selector: '[appDynamicHost]'
} )
export class DynamicHost
{
  public field = input<any>();
  public control = model<any>();
  constructor( public viewContainerRef: ViewContainerRef ) { }
}
